import { inject, Injectable } from "@angular/core";
import { CapturedResponses, GroupByApiResult, GroupByPayload } from "../models/vcloud-api";
import { MAX_API_RESPONSE_LIMIT, ROWS_PER_PAGE } from "../constant/vcloud-api";
import { CAPTURE_RESPONSE } from "./service.constants";
import { LoggerService } from "./logger.service";

@Injectable({
  providedIn: "root",
})
export class VcloudDebugCaptureService {
  private logger = inject(LoggerService);

  public set capturedResponses(value: CapturedResponses) {
    sessionStorage.setItem(CAPTURE_RESPONSE.STORAGE_KEY, JSON.stringify(value));
  }

  public get capturedResponses(): CapturedResponses {
    const maybe = sessionStorage.getItem(CAPTURE_RESPONSE.STORAGE_KEY);
    if (maybe) {
      try {
        const value = JSON.parse(maybe);
        if (value) {
          return value;
        }
      } catch (e) {
        this.logger.error("Failed to parse captured responses from sessionStorage", e);
      }
    }
    return { [location.pathname]: [] };
  }

  public captureResponse(
    response: GroupByApiResult,
    body: GroupByPayload,
    stableStringify: (payload: GroupByPayload) => string,
  ): void {
    const key = location.pathname;
    if (key.includes(CAPTURE_RESPONSE.EXCLUDED_PATH)) {
      return;
    }
    const cellCount = (response?.Results?.length ?? 0) * (body?.Projection?.length ?? 0);
    const stringifiedBody = stableStringify(body);
    if (cellCount > 0 && !this.isFiltersRequest(body)) {
      const cr = this.capturedResponses;
      cr[key] = (cr[key] ?? [])
        .filter((f) => stableStringify(f.body) !== stringifiedBody)
        .slice(-CAPTURE_RESPONSE.MAX_HISTORY);
      cr[key].push({ body, results: response.Results?.slice(0, CAPTURE_RESPONSE.MAX_RESULTS) ?? [] });
      this.capturedResponses = cr;
    }
  }

  private isFiltersRequest(body: GroupByPayload): boolean {
    return (
      (body?.GroupBy?.length ?? 0) === 0 &&
      (body?.GroupByV2?.length ?? 0) === 0 &&
      body?.Distinct === true &&
      body?.Projection?.length === 1 &&
      ((body?.Limit ?? ROWS_PER_PAGE) === ROWS_PER_PAGE ||
        (body?.Limit ?? MAX_API_RESPONSE_LIMIT) === MAX_API_RESPONSE_LIMIT) &&
      !body?.Projection[0].Operation
    );
  }
}
